<template>
  <select-panel-modal
    modalTitle="选择账号"
    label="广告账号"
    panelTitle="请选择广告账号"
    inputPlaceholder="请输入名称或ID搜索"
    v-model="selectedIds"
    :panelOptions="panelOptions"
    :isInited="selectPanelOptionInited"
    :isSelectPanelLoading="isSelectPanelLoading"
    @selectPanelShow="initSelectPanelOptionList"
  ></select-panel-modal>
</template>

<script>
import NbsApis from 'Src/const/nbsApis'
import SelectPanelModal from 'Src/components/reporter/input/select-panel-modal/index.vue'

const ADV_LIST_LIMIT = 100

export default {
  name: 'account-select',
  components: {
    [SelectPanelModal.name]: SelectPanelModal
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      panelOptions: [],
      selectPanelOptionInited: false,
      isSelectPanelLoading: true
    }
  },
  computed: {
    selectedIds: {
      get() { return this.value},
      set(val) { this.$emit('valueChanged', val)}
    }
  },
  methods: {
    fetchData (options) {
      const { url, data } = options
      const vm = this
      return new Promise((resolve, reject) => {
        return BUI.fetch({
          url,
          data,
          success: (resp) => {
            if (resp.code === 0) {
              resolve(resp)
            } else {
              vm.$message(resp.msg || '系统错误', 'error')
              reject(resp)    //  eslint-disable-line
            }
          },
          error: function (error) {
            vm.$message(error.msg || '系统错误', 'error')
            reject(error)     //  eslint-disable-line
          }
        })
      })
    },
    fetchAdvList(page) {
      const options = { 
        url: NbsApis.reporter.adv_list_bp, 
        data: { page: page, limit: ADV_LIST_LIMIT }
      }
      return this.fetchData(options);
    },
    async getAllAdvList() {
      try {
        let { code, data } = await this.fetchAdvList(1);
        if (code === 0) {
          const { accounts = [], pagination } = data ?? {}
          // 接口分页，但是组件目前不支持分页，需要全量的数据，这里一次请求所有的页面
          const totalPages = Math.ceil(pagination?.total / pagination?.limit)
          const promises = [...Array(totalPages)]
            .filter((i, index) => index > 0)
            .map((i, index) => this.fetchAdvList(index + 1))
          const allRes = await Promise.all(promises)
          const restAccounts = allRes.reduce((allList, res) => {
            const lst = res?.data?.accounts ?? []
            return [...allList, ...lst]
          }, [])
          const allAccounts = [...accounts, ...restAccounts]
          const optionList = allAccounts.map(adv => {
            return {
              id: adv.id,
              originId: adv.id,
              name: adv.name,
              childrenLoaded: false,
              renderName: (name) => {
                return (
                  <byted-tooltip
                    hideDelay={0}
                    transfer
                    placement="left"
                    trigger="hover"
                  >
                    {name}
                    <span slot="reference">{name}</span>
                  </byted-tooltip>
                )
              }
            }
          })
          this.panelOptions = Object.freeze(optionList)
        }
        this.isSelectPanelLoading = false;
        this.selectPanelOptionInited = true;
      } catch (e) {
        console.error(e)
        this.isSelectPanelLoading = false;
      }
    },
    async initSelectPanelOptionList() {
      this.panelOptions = []
      this.isSelectPanelLoading = true;
      this.getAllAdvList()
    }
  }
}
</script>

<style>
</style>